/**
 * Created by rathompson on 5/9/22
 * File: NoDataScreen
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */
import type { CSSProperties, VFC } from 'react'
import { EmptyStateLayout, EmptyStateLayoutProps } from '@panwds/react-ui'

const NoDataScreen: VFC<EmptyStateLayoutProps & {
  className?: string,
  addClassName?: string,
  layoutStyle?: CSSProperties
}> = ({
  heading,
  description,
  actions,
  style: _style = {},
  className: _className = 'tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-items-center',
  addClassName = '',
  graphic,
  layoutStyle = {}
}) => {

  const style = Object.assign({ height: '75%' }, _style)
  const className = `${_className} ${addClassName}`.trim()

  return (
    <div {...{ className, style }}>
      <EmptyStateLayout
        {...{ heading, description, graphic, style: layoutStyle }}
        actions={(
          <div className='tw-flex tw-gap-2 tw-justify-center'>
            {actions}
          </div>
        )}
      />
    </div>
  )
}

export default NoDataScreen
